<template>
  <div class="reportTemplatePage">
    <div class="formWrap">
      <Form>
        <FormItem label="选择分类" required :label-col="labelCol" :wrapper-col="wrapperCol">
          <Row>
            <Col :span="12">
              <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" @select="choiceTreeCode" v-model="formInfo.parentCode" :disabled="editFlag">
                <SelectOption v-for="(item, index) in firstTypeList" :value="item.id" :key="index">{{item.name}}</SelectOption>
              </Select>
            </Col>
            <Col :span="12">
              <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model="formInfo.childCode" :disabled="editFlag" @change="choiceSecondValue">
                <SelectOption v-for="(item, index) in secondTypeList" :value="item.id" :key="index">{{item.name}}</SelectOption>
              </Select>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="模板名称" required :label-col="labelCol" :wrapper-col="wrapperCol">
          <Input v-model="formInfo.tempName" :disabled="editFlag"></Input>
        </FormItem>
        <FormItem label="影像表现" required :label-col="labelCol" :wrapper-col="wrapperCol">
          <TextArea v-model="formInfo.imageRepresentation" :disabled="editFlag" :maxlength="700"></TextArea>
          <span class="lengthTip">还能输入{{700 - formInfo.imageRepresentation.length}}字</span>
        </FormItem>
        <FormItem label="影像诊断" required :label-col="labelCol" :wrapper-col="wrapperCol">
          <TextArea v-model="formInfo.imageDiagnose" :disabled="editFlag" :maxlength="700"></TextArea>
          <span class="lengthTip">还能输入{{700 - formInfo.imageDiagnose.length}}字</span>
        </FormItem>
        <FormItem label="病种标签" :label-col="labelCol" :wrapper-col="wrapperCol">
          <div class="diseaseWrap">
            <Select :getPopupContainer="triggerNode =>(triggerNode.parentNode)" mode="multiple" labelInValue allowClear  :disabled="editFlag" class="selectList" v-model="choicedItem" :filterOption="false" @search="searchDiease"  @change="selectDiease" :notFoundContent="dieaseLoading ? undefined : null" optionLabelProp="name">
              <SelectOption v-for="item in fetchDieases" :key="item.id + '|'+item.icd10_code" :name="item.name">{{item.icd10_code}} {{item.name}}</SelectOption>
              <Spin v-if="dieaseLoading" slot="notFoundContent"/>
            </Select>
          </div>
        </FormItem>
      </Form>
    </div>
    <div class="footer">
      <div class="wrapper">
        <div><Button v-if="tempInfo.report_name && editFlag" size="large" @click="clearTemp" :loading="clearTempLoading">删除</Button></div>
        <div>
          <Button size="large" @click="removeModal">取消</Button>
          <Button size="large" v-if="tempInfo.report_name && editFlag" @click="editDocTemp">编辑</Button>
          <Button size="large" type="primary" v-if="tempInfo.report_name && !editFlag" @click="sureAddDocTemp" :loading="sureAddDocTempFlag">保存</Button>
          <Button size="large" v-if="tempInfo.report_name && editFlag" @click="replaceTemp">覆盖</Button>
          <Button size="large" type="primary" v-if="tempInfo.report_name && editFlag" @click="addToTemp">追加</Button>
          <Button size="large" type="primary" v-if="!tempInfo.report_name" @click="sureAddDocTemp" :loading="sureAddDocTempFlag">确认</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Form, Select, Row, Col, Input, Modal, Spin } from 'ant-design-vue'
import { addDoctorTemp, editDoctorTemp } from '../../api/report'
import { mapActions } from 'vuex'
import { getDoctorFirstTempList, getDoctorSecondTempList, deleteTemplate } from '../../api/report'
import { getDieaseByVal} from '../../api/report'
export default {
  props: {
    classInfo: {
      type: Array,
      default: () => []
    },
    tempInfo: {
      type: Object,
      default: () => {}
    },
    reportId: {
      type: String,
      default: ''
    }
  },
  components: {
    Button,
    Form,
    FormItem: Form.Item,
    Select,
    SelectOption: Select.Option,
    Row,
    Col,
    Input,
    TextArea: Input.TextArea,
    Spin
  },
  data () {
    return {
      labelCol: {
        lg: { span: 4 }, xl: { span: 5 }, xxl: { span: 4 }
      },
      wrapperCol: {
        lg: { span: 16 }, xl: { span: 16 }, xxl: { span: 16 }
      },
      classSecond: [],
      formInfo: {
        parentCode: '',
        childCode: undefined,
        tempName: '',
        imageRepresentation: '',
        imageDiagnose: ''
      },
      editFlag: false,
      dieaseKeyWrod: '', // 搜索关键词
      fetchDieases: [], // 疾病标签列表
      dieaseLoading: false,
      searchTimer: null,
      paramsDiease: [],
      choicedItem: [],
      firstTypeList: [],
      secondTypeList: [],
      sureAddDocTempFlag: false,
      clearTempLoading: false
    }
  },
  mounted () {
    if (this.tempInfo.report_name) {
      this.formInfo = {
        tempName: this.tempInfo.report_name,
        imageRepresentation: this.tempInfo.image_representation,
        imageDiagnose: this.tempInfo.diagnostic_result,
        parentCode: this.tempInfo.category_id,
        childCode: this.tempInfo.sub_category_id
      }
      if (this.tempInfo.disease_list && this.tempInfo.disease_list.length > 0) {
        this.paramsDiease = JSON.parse(this.tempInfo.disease_list)
        let arr = JSON.parse(this.tempInfo.disease_list)
        for (let i = 0; i < arr.length; i++) {
          let item = arr[i]
          this.choicedItem.push({key: item.id + '|' + item.code, id: item.id, originKey: item.code, label: item.name})
        }
      }
      this.editFlag = true
      this.classInfo.map(item => {
        if (item.key === this.tempInfo.category_id) {
          this.choiceTreeCode(item.key)
        }
      })
    }
    if (this.tempInfo.flag === 'save') {
      this.formInfo = {
        imageRepresentation: this.tempInfo.image_representation,
        imageDiagnose: this.tempInfo.diagnostic_result,
        tempName: this.tempInfo.templateName
      }
      this.choicedItem = this.tempInfo.diseaseData
      for (let i = 0; i < this.tempInfo.diseaseData.length; i++) {
        let item = this.tempInfo.diseaseData[i]
        this.paramsDiease.push({code: item.originKey, id: item.id, name: item.label})
      }
    }
    if (this.tempInfo.flag === 'add') {
      this.classInfo.map(item => {
        if (item.key === this.tempInfo.parentId) {
          this.choiceTreeCode(item.key)
        }
      })
      this.formInfo.parentCode = this.tempInfo.parentId
      this.formInfo.childCode = this.tempInfo.key
    }
    this.getDocTempData()
  },
  methods: {
    ...mapActions([
      'setDiagnosticResult',
      'setImageRepresentation',
      'addToImageRepresentation',
      'addToDiagnosticResult',
      'setDieaseList',
      'addDieaseList'
    ]),
    async choiceTreeCode (value) {
      let result = await getDoctorSecondTempList({ orderCheckReportId: this.reportId, parentId: value})
      if (result) {
        this.secondTypeList = result
      }
    },
    choiceSecondValue (value) {
      this.formInfo.childCode = value
    },
    // 获取一级分类
    async getDocTempData () {
      let data = await getDoctorFirstTempList({ orderCheckReportId: this.reportId})
      if (data) this.firstTypeList = data
    },
    // 编辑模板
    editDocTemp () {
      this.editFlag = false
    },
    // 确认保存报告模板
    async sureAddDocTemp () {
      if (!this.formInfo.parentCode) return Modal.error({ title: '请选择分类' })
      if (!this.formInfo.childCode) return Modal.error({ title: '请选择分类' })
      if (!this.formInfo.tempName) return Modal.error({ title: '请填写模板名称' })
      if (!this.formInfo.imageRepresentation) return Modal.error({ title: '请填写影像表现' })
      if (!this.formInfo.imageDiagnose) return Modal.error({ title: '请填写影像诊断' })
      if (this.sureAddDocTempFlag) return false
      this.sureAddDocTempFlag = true
      let params = {
        categoryId: this.formInfo.parentCode,
        subCategoryId: this.formInfo.childCode,
        reportName: this.formInfo.tempName,
        imageRepresentation: this.formInfo.imageRepresentation,
        diagnosticResult: this.formInfo.imageDiagnose,
        positiveNegative: '1',
        platform: 'applet'
      }
      if (this.paramsDiease.length !== 0) {
        params.diseaseList = JSON.stringify(this.paramsDiease)
      }
      this.firstTypeList.map(item => {
        if (item.id === this.formInfo.parentCode) {
          params.categoryName = item.name
        }
      })
      this.secondTypeList.map(item => {
        if (item.id === this.formInfo.childCode) {
          params.subCategoryName = item.name
        }
      })
      if (this.tempInfo.id) {
        let sendInfo = {
          id: this.tempInfo.id,
          category_id: this.formInfo.parentCode,
          sub_category_id: this.formInfo.childCode,
          report_name: this.formInfo.tempName,
          image_representation: this.formInfo.imageRepresentation,
          diagnostic_result: this.formInfo.imageDiagnose,
          positive_negative: '1',
          platform: 'applet'
        }
        if (this.paramsDiease.length !== 0) {
          sendInfo.disease_list = JSON.stringify(this.paramsDiease)
        }
        let data = await editDoctorTemp(sendInfo)
        this.sureAddDocTempFlag = false
        if (data) this.editFlag = true
      } else {
        let data = await addDoctorTemp(params)
        this.sureAddDocTempFlag = false
        if (data) this.$emit('handleCancel')
      }
    },
    // 删除模板
    async clearTemp () {
      if (this.clearTempLoading) return false
      this.clearTempLoading = true
      let data = await deleteTemplate({ id: this.tempInfo.id})
      if (data) {
        this.$emit('deleteTemplate')
        this.clearTempLoading = false
      }
    },
    // 替换模板 
    replaceTemp () {
      this.setImageRepresentation(this.formInfo.imageRepresentation)
      this.setDiagnosticResult(this.formInfo.imageDiagnose)
      this.setDieaseList(this.choicedItem)
      this.removeModal()
    },
    // 追加模板
    addToTemp () {
      this.addToImageRepresentation(this.formInfo.imageRepresentation)
      this.addToDiagnosticResult(this.formInfo.imageDiagnose)
      this.addDieaseList(this.choicedItem)
      this.removeModal()
    },
    removeModal () {
      this.$emit('handleCancel')
    },
    async searchDiease (val) {
      if (this.searchTimer) return false
      this.searchTimer = setTimeout(async() => {
        this.dieaseLoading = true
        this.fetchDieases = []
        if (!val || !val.trim()) return false
        this.dieaseKeyWrod = val.trim()
        let list = await getDieaseByVal({value: val.trim()})
        if (list && list.length > 0) this.fetchDieases = list
        this.dieaseLoading = false
        clearTimeout(this.searchTimer)
        this.searchTimer = null
      }, 1000)
    },
    selectDiease (val) {
      let dieaseList = []
      for (let i = 0; i < val.length; i++) {
        let item = val[i]
        let idAndKey = item.key.split('|')
        dieaseList.push({code: idAndKey[1], id: idAndKey[0], name: item.label})
      }
      this.fetchDieases = []
      this.paramsDiease = dieaseList
      this.dieaseLoading = false
    }
  }
}
</script>

<style lang="less">
@import url('../../style/index.less');
.reportTemplatePage{
  .footer{
    .wrapper{
      margin-top: 20px;
      padding: @LeaveDistance @LeaveDistance 0 @LeaveDistance;
      border-top: 1px solid @divideLineColor;
      display: flex;
      justify-content: space-between;
      button{
        margin-right: 0;
        margin-left: @LeaveDistance;
      }
    }
  }
  .lengthTip{
    font-size: @smallFontSize;
    position: absolute;
    width: 100px;
    top: 15px;
    left: 0px;
  }
}
</style>